import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

/**
 * PageViewTracker — sends a GA4 page_view on every SPA route change (T22.245).
 *
 * GA is configured with send_page_view:false (utils/analytics.js), so without
 * this nothing ever recorded a page view: trackPageView had no caller and GA
 * showed 0 page views. Renders nothing. trackPageView is a no-op until consent
 * is granted and GA is initialized (and for DNT / minor mode), and skips the
 * page initGa already sent, so mounting it unconditionally is safe.
 */
export default function PageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
}
